import { makeAutoObservable, runInAction } from "mobx";
import { Store, IDashboardStore, DashboardStatistics } from "../global/types";
import { getDashboardStatistics } from "../api/user.action";
  
class DashboardStore implements IDashboardStore {
    rootStore: Store;
    dashboardStatistics: DashboardStatistics | null = null
    error: string | null = null;
    loading: boolean = false; 

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchDashboardStatistics = async() => {
        this.setLoading(true);
        try {
            const response = await getDashboardStatistics();
            runInAction(() => {
               this.dashboardStatistics = response.data
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    resetDashboardData = () => {
        runInAction(() => {
            this.error = null;
            this.dashboardStatistics = null;
            this.loading = false;
        })
    }
}

export default DashboardStore;
